import React from 'react'
import { Box, Drawer, List } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import backIcon from '../../assets/images/back.svg'
import { PowerOff } from '../../components/Icons'
import NavItem from './NavItem'

const items = [
  {
    href: '/portfolio',
    icon: backIcon,
    title: 'Portfolio',
    active: true,
  },
]

const drawerWidth = 64

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      overflowX: 'hidden',
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      backgroundColor: '#1B3963',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    avatarBox: {
      marginTop: 18,
      marginBottom: 50,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    avatar: {
      background: '#FFC42C',
      width: 40,
      height: 40,
      fontSize: 14,
      fontWeight: 600,
      color: '#1B3963',
    },
    listItem: {
      display: 'block',
    },
    toggleBtn: {
      color: '#ffffff',
      '& img': {
        width: 24,
        height: 24,
      },
    },
    toggleBtnCollapse: {
      color: '#ffffff',
      '& img': {
        width: 24,
        height: 24,
        transform: 'rotateY(180deg)',
      },
    },
    sideItemContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '100%',
      width: '100%',
    },
    sideItemGroupTop: {
      width: '100%',
      marginTop: 84,
    },
    sideItemGroupDown: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    customListNav: {
      padding: 0,
    },
    sideItemCommon: {
      height: 48,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
    logOutLabel: {
      color: '#FFFFFF',
      fontSize: 10,
      opacity: '0.6',
    },
  }),
)

const NavBar = () => {
  const classes = useStyles()
  const history = useHistory()
  const isPortfolioPage =
    window.location.pathname === '/' ||
    window.location.pathname.indexOf('portfolio') !== -1

  const onHandleLogout = () => {
    localStorage.clear()
    document.cookie.split(';').forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`)
    })
    window.location.href = '/login'
  }

  return (
    <Drawer
      variant="permanent"
      className={classes.drawer}
      classes={{
        paper: classes.drawer,
      }}
    >
      <div className={classes.sideItemContainer}>
        <div className={classes.sideItemGroupTop}>
          {!isPortfolioPage && (
            <Box>
              <List className={classes.customListNav}>
                {items.map(item => (
                  <NavItem
                    href={item.href}
                    key={item.title}
                    title={item.title}
                    icon={item.icon}
                    active={item.active}
                    hiddenTitle
                  />
                ))}
              </List>
            </Box>
          )}
        </div>
        <div className={classes.sideItemGroupDown}>
          <span className={classes.logOutLabel}>Log Out</span>
          <Box onClick={onHandleLogout} className={classes.sideItemCommon}>
            <PowerOff />
          </Box>
        </div>
      </div>
    </Drawer>
  )
}

export default NavBar
